import * as React from "react";
const SVGComponent = ({ color = "#5E4DC3", ...props }) => (
  <svg
    width={32}
    height={45}
    viewBox="0 0 32 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 45C16 45 32 28.5929 32 15.75C32 7.05161 24.8366 0 16 0C7.16339 0 0 7.05152 0 15.75C0 28.5929 16 45 16 45ZM16 23.85C20.5445 23.85 24.2286 20.2235 24.2286 15.7497C24.2286 11.2763 20.5445 7.64982 16 7.64982C11.4555 7.64982 7.77143 11.2763 7.77143 15.7497C7.77143 20.2234 11.4555 23.85 16 23.85Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;